import type { PropType } from 'virtual-vue';
import type { ResultIcon } from './result';

export const DEFAULT_RESULT_ICON = '';

/**
 * Result 组件的 props
 * 基于方案设计文档生成
 */
export const props = {
  /**
   * 自定义图标名称
   * 可选值为 success（操作成功）info（提示）danger（强烈警告）warning（普通警告）waiting（等待）
   * 为空时不显示icon
   * @default ''
   */
  icon: {
    type: String as PropType<ResultIcon>,
    default: DEFAULT_RESULT_ICON,
  },
  /**
   * 标题文本
   * @default ''
   */
  title: {
    type: String,
    default: '',
  },
  /**
   * 头部描述文本
   * @default ''
   */
  description: {
    type: String,
    default: '',
  },
};

